export default "__VITE_ASSET__cf9858aa__"